import { TabStyles } from '@tableau/widgets';

export const asyncContentPlaceholderStyles: React.CSSProperties = {
  marginBottom: TabStyles.Spacing.LargeSpace,
};

export const spinnerStyles: React.CSSProperties = {
  paddingTop: TabStyles.Spacing.LargeSpace*2,
  textAlign: 'center',
};

export const workbooksAffectedStyles: React.CSSProperties = {
  fontWeight: 'bold',
  marginBottom: TabStyles.Spacing.MediumSpace,
  wordWrap: 'break-word',
};

export const tableStyles: React.CSSProperties = {
  width: '100%',
};

export const tablePropertyStyles: React.CSSProperties = {
  whiteSpace: 'nowrap',
  verticalAlign: 'top',
};

export const tableValueStyles: React.CSSProperties = {
  wordWrap: 'break-word',
  paddingLeft: TabStyles.Spacing.MediumSpace,
};

export const notificationStyles: React.CSSProperties = {
  marginTop: '0px',
};

export const actionsFooterStyles: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
};

export const connectionDetailsStyles: React.CSSProperties = {
  padding: TabStyles.Spacing.SmallSpace,
};
